export default __webpack_public_path__ + "static/media/gold-divider-bottom.d5270060.svg";